import { createQueryKeys } from "@lukemorales/query-key-factory"

import API from "../../index"
import { CommonRequestParams } from "api/api.types"

export const settingsQueryKeys = createQueryKeys("settings", {
  getSettings: (params?: CommonRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.Settings.getSettings(params),
  }),
})
